import { createApiCallActions } from '../../../common/store/generic.actions';
import { ContractTerminationReasonModel } from './types';

export const contractTerminationReasonActions = {
  getById: createApiCallActions<ContractTerminationReasonModel>(
    'contractTerminationReason',
    'getById',
  ),
  createInstance: createApiCallActions<ContractTerminationReasonModel>(
    'contractTerminationReason',
    'createInstance',
  ),
  add: createApiCallActions<ContractTerminationReasonModel>(
    'contractTerminationReason',
    'add',
  ),
  update: createApiCallActions<ContractTerminationReasonModel>(
    'contractTerminationReason',
    'update',
  ),
};

export type ContractTerminationReasonAction =
  typeof contractTerminationReasonActions;
